<script>
import VueTypeaheadBootstrap from "@/components/vueTypeAheadBootstrap/VueTypeaheadBootstrap";
import required from "vuelidate/lib/validators/required";
import Multiselect from "vue-multiselect";

// Custom Components
import PageHeader from "@/components/page-header";
import TicketService from "@/helpers/APIService/ticket.service";
import PbxService from "@/helpers/APIService/pbx.service";
import SuperService from "@/helpers/APIService/super.service";
import MediaService from "@/helpers/APIService/media.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import appConfig from "@/app.config";
import moment from "moment";

export default {
  namepage: {
    title: "Pbx Ticket Details",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
    VueTypeaheadBootstrap,
    Multiselect,
  },
  data() {
    return {
      isLoading: false,
      isEdit: false,
      ticket_form_data: {},
      add_note_form: {
        is_internal: true,
        status: "",
      },
      statusOptions: [
        { text: "Assigned", value: "assigned", disabled: false },
        { text: "OpenL1", value: "openL1", disabled: false },
        { text: "OpenL2", value: "openL2", disabled: false },
        { text: "OpenL3", value: "openL3", disabled: false },
        { text: "Development", value: "development", disabled: false },
        { text: "Closed", value: "closed", disabled: false },
      ],
      priorityOptions: [
        {
          text: "High",
          value: "high",
        },
        {
          text: "Urgent",
          value: "urgent",
        },
        {
          text: "Normal",
          value: "normal",
        },
      ],
      assignedToOptions: [],
      domain_list_options: [],
      titleData: [],
      submitted: false,
      isBtnLoading: false,
      isError: false,
      errorMessage: null,
      fileObject: null,
      mediaUrl: "",
      waitingURL: "",
      domain_name: "",
    };
  },
  validations: {
    add_note_form: { description: { required } },
    ticket_form_data: {
      ticket_title: { required },
      priority: { required },
      assign_to_user_uuid: { required },
      caller_name: { required },
      caller_email: { required },
      caller_number: { required },
    },
  },
  mounted() {
    this.setValue();
    this.add_note_form.is_internal = true;
  },
  methods: {
    // Method is used to set value
    setValue() {
      // get domain list
      if (localStorage.domain_list) {
        const domainList = JSON.parse(
          atob(localStorage.getItem("domain_list"))
        );
        this.setDomainOptions(domainList);
      } else {
        PbxService.getDomainList(`?column=domain_uuid&column=domain_name`)
          .then((response) => {
            if (response.status == false) {
              return Middleware.notification(response.message, "warning");
            } else {
              this.setDomainOptions(response);
            }
          })
          .catch((error) => {
            errorHandler(error);
          });
      }
      TicketService.getTicketTitleList()
        .then((response) => {
          if (response.status == false) {
            return Middleware.notification(response.message, "warning");
          } else {
            this.titleData = response.result;
          }
        })
        .catch((error) => {
          errorHandler(error);
        });
      this.isLoading = true;
      this.getTicketDetails();
    },
    // Method is used to get user list
    async getUserList() {
      try {
        const supportUser = await SuperService.getCdxUserList();
        const hotelUser = await SuperService.getHotelUserList();
        supportUser.map((user) => {
          this.assignedToOptions.push({
            text: `${user.first_name}  ${user.last_name} (Support Staff)`,
            value: user.id,
            user: user,
            user_type: "support_staff",
          });
        });
        hotelUser.map((user) => {
          this.assignedToOptions.push({
            text: `${user.first_name}  ${user.last_name} (Hotel Admin)`,
            value: user.id,
            user: user,
            user_type: "hotel_user",
          });
        });
        this.assignedToOptions.find((item) => {
          if (typeof this.ticket_form_data.assign_to_user_uuid == "object") {
            item.value == this.ticket_form_data.assign_to_user_uuid.value;
          } else {
            this.ticket_form_data.assign_to_user_uuid = item;
            item.value == this.ticket_form_data.assign_to_user_uuid;
          }
        });
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is used to get ticket details
    getTicketDetails() {
      TicketService.getTicketDetail(
        this.$route.params.ticketId,
        this.$route.query.domain_uuid
      )
        .then((response) => {
          this.isLoading = false;
          if (response.status == false) {
            return Middleware.notification(response.message);
          }
          if (response.result) {
            this.ticket_form_data = response.result;
            this.add_note_form.status = this.ticket_form_data.status;
            let media_url = "";
            const fillerUrl = this.ticket_form_data.attached_file;
            if (fillerUrl != null && fillerUrl != "") {
              const fileExtension = fillerUrl.split(".").pop().toLowerCase();
              if (fileExtension.includes("jpg")) {
                media_url = fillerUrl.replace(/\.jpg.*/, ".jpg");
              } else if (fileExtension.includes("png")) {
                media_url = fillerUrl.replace(/\.png.*/, ".png");
              } else if (fileExtension.includes("jpeg")) {
                media_url = fillerUrl.replace(/\.jpeg.*/, ".jpeg");
              }
            }
            for (
              let index = 0;
              index < this.ticket_form_data.ticket_activities.length;
              index++
            ) {
              let medias = "";
              let element = this.ticket_form_data.ticket_activities[index];
              if (element.attachment != null && element.attachment != "") {
                const fillerUrl = element.attachment; // Replace with the actual file URL
                if (fillerUrl != null && fillerUrl != "") {
                  const fileExtension = fillerUrl
                    .split(".")
                    .pop()
                    .toLowerCase();
                  if (fileExtension.includes("jpg")) {
                    medias = fillerUrl.replace(/\.jpg.*/, ".jpg");
                  } else if (fileExtension.includes("png")) {
                    medias = fillerUrl.replace(/\.png.*/, ".png");
                  } else if (fileExtension.includes("jpeg")) {
                    medias = fillerUrl.replace(/\.jpeg.*/, ".jpeg");
                  }
                }
                this.ticket_form_data.ticket_activities[index] = {
                  ...this.ticket_form_data.ticket_activities[index],
                  attached: medias,
                };
              }
            }
            this.ticket_form_data = {
              ...this.ticket_form_data,
              attachment: media_url,
            };
            this.handleTicketStatus(this.ticket_form_data.status);
          }
        })
        .catch((error) => {
          this.isLoading = false;
          errorHandler(error);
        });
    },
    // Method is used to set domain options
    setDomainOptions(data) {
      data.forEach((item) => {
        this.domain_list_options.push({
          value: item.domain_uuid,
          text: item.domain_name,
        });
      });
      for (let index = 0; index < this.domain_list_options.length; index++) {
        const element = this.domain_list_options[index];
        if (element.value == this.$route.query.domain_uuid) {
          this.domain_name = element.text;
        }
      }
    },
    // Method is used to add new note
    async addNewNote() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
      } else {
        if (this.fileObject != null) {
          let fileUrl = "";
          let extensions = [
            "jpg",
            "png",
            "jpeg",
            "tiff",
            "pdf",
            "webp",
            "heic",
            "heif",
            "bmp",
            "doc",
            "docx",
            "ppt",
            "pptx",
          ];
          extensions.forEach((element) => {
            if (this.mediaUrl.name.includes(element)) {
              let pattern = new RegExp(`\\.${element}.*`);
              fileUrl = this.mediaUrl.name.replace(
                pattern,
                `_${this.randomString(5)}_.${element}`
              );
            }
          });
          await MediaService.mediaFileUrlGenerate(
            {
              file_name: `ticket_${fileUrl}`,
              file_location: this.domain_name + "/support-ticket",
            },
            this.$route.query.domain_uuid
          )
            .then((response) => {
              let fileUrl = response.result;
              this.waitingURL = response.result;
              MediaService.mediaFileUpload(fileUrl, this.mediaUrl).then(() => {
                this.finalSubmit("file");
              });
            })
            .catch((error) => {
              errorHandler(error);
            });
        } else {
          this.finalSubmit("none");
        }
      }
    },
    finalSubmit(type) {
      if (type == "file") {
        const fillerUrl = this.waitingURL;
        if (fillerUrl != null && fillerUrl != "") {
          this.waitingURL = fillerUrl.split("?")[0];
        } else {
          return Middleware.notification(
            "File type is not suppoerted !!",
            "danger"
          );
        }
        this.add_note_form.attachment = this.waitingURL;
      }
      TicketService.updateTicketDetail(
        this.$route.params.ticketId,
        this.add_note_form,
        this.$route.query.domain_uuid
      )
        .then((response) => {
          this.isBtnLoading = false;
          if (response.status == false) {
            return Middleware.notification(response.message, "danger");
          }
          Middleware.notification("Note added successfully !!", "success");
          this.resetModal();
          this.getTicketDetails();
          this.add_note_form = {};
          this.submitted = false;
        })
        .catch((error) => {
          this.isError = true;
          this.isBtnLoading = false;
          this.errorMessage = error.response.data;
          this.isBtnLoading = false;
          errorHandler(error);
        });
    },
    // Method is used to update ticket
    updateTicket() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.ticket_form_data.$touch();
      if (this.$v.ticket_form_data.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        this.isBtnLoading = true;
        const data = {
          ticket_title: this.ticket_form_data.ticket_title,
          priority: this.ticket_form_data.priority,
          status: this.ticket_form_data.status,
          assign_to_user_uuid: this.ticket_form_data.assign_to_user_uuid.value,
          caller_name: this.ticket_form_data.caller_name,
          caller_email: this.ticket_form_data.caller_email,
          caller_number: this.ticket_form_data.caller_number,
          assign_to_user_name:
            this.ticket_form_data.assign_to_user_uuid.user.first_name +
            " " +
            this.ticket_form_data.assign_to_user_uuid.user.last_name,
        };
        TicketService.updateTicket(
          this.$route.params.ticketId,
          data,
          this.$route.query.domain_uuid
        )
          .then((response) => {
            this.isEdit = false;
            this.submitted = false;
            this.isBtnLoading = false;
            if (response.status == false) {
              return Middleware.notification(response.message, "danger");
            }
            Middleware.notification("Successfully updated !!", "success");
            this.handleTicketStatus(response.result.status);
          })
          .catch((error) => {
            this.isEdit = false;
            this.submitted = false;
            this.isError = true;
            this.isBtnLoading = false;
            this.errorMessage = error.response.data;
            errorHandler(error);
          });
      }
    },
    // Method is used to reset modal
    resetModal() {
      this.$bvModal.hide("add-note-modal");
    },
    // Method is used to go back
    goBack() {
      this.$router.push("/pbx-ticket");
    },
    // Method is used to conver time
    convertTime(date) {
      return moment(date).format("YYYY-MM-DD / hh:mm A");
    },
    // Method is used to handle change of ticket title
    handleHit(trackBy, data = null) {
      if (data !== null) {
        this.ticket_form_data.title = data[trackBy];
      }
    },
    // Method is used to handle ticket status
    handleTicketStatus(ticket_status) {
      this.add_note_form.status = ticket_status;
      if (ticket_status == "assigned") {
        this.statusOptions = this.statusOptions.filter(
          (item) => item.value !== "assigned"
        );
      }
      if (ticket_status == "development") {
        this.statusOptions = [
          { text: "OpenL1", value: "openL1", disabled: false },
          { text: "OpenL2", value: "openL2", disabled: false },
          { text: "OpenL3", value: "openL3", disabled: false },
          { text: "Closed", value: "closed", disabled: false },
        ];
      }
      if (ticket_status == "openL1") {
        this.statusOptions = [
          { text: "OpenL2", value: "openL2", disabled: false },
          { text: "OpenL3", value: "openL3", disabled: false },
          { text: "Development", value: "development", disabled: false },
          { text: "Closed", value: "closed", disabled: false },
        ];
      }
      if (ticket_status == "openL2") {
        this.statusOptions = [
          { text: "OpenL3", value: "openL3", disabled: false },
          { text: "Development", value: "development", disabled: false },
          { text: "Closed", value: "closed", disabled: false },
        ];
      }
      if (ticket_status == "openL3") {
        this.statusOptions = [
          { text: "Development", value: "development", disabled: false },
          { text: "Closed", value: "closed", disabled: false },
        ];
      }
    },
    // Method is used to edit ticket details
    handleEdit() {
      this.getUserList();
      this.isEdit = !this.isEdit;
    },
    // Method is used to handle upload file
    uploadFile(event) {
      this.mediaUrl = event.target.files[0];
      this.fileObject = this.mediaUrl;
      const mimeTypes = [
        "image/jpeg",
        "image/png",
        "image/jpeg",
        "image/tiff",
        "application/pdf",
        "image/webp",
        "image/heic",
        "image/heif",
        "image/bmp",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      ];
      let supportedFile = false;
      mimeTypes.forEach((element) => {
        if (this.fileObject.type == element) {
          supportedFile = true;
        }
      });
      if (!supportedFile) {
        Middleware.notification(
          `${this.fileObject.name} is not supported !!`,
          "info"
        );
        this.fileObject = null;
        return;
      }
    },
    // Method is used to generate random string
    randomString(length) {
      var result = "";
      var characters = "abcdefghijklmnopqrstuvwxyz";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
    viewAttachment(url) {
      let htmlContent = "";
      // Generate an HTML page with the image embedded
      if (
        url.includes("jpg") ||
        url.includes("png") ||
        url.includes("jpeg") ||
        url.includes("webp") ||
        url.includes("heic")
      ) {
        htmlContent = `
                <html>
                  <body>
                    <img src="${url}" />
                  </body>
                </html>
               `;
      } else if (
        url.includes("pdf") ||
        url.includes("ppt") ||
        url.includes("pptx")
      ) {
        htmlContent = `
                <html>
                  <body>
                    <div>
                      <iframe src="${url}" style="width:100%; height:100%;"></iframe>
                    </div>
                  </body>
                </html>
              `;
      }

      // Create a Blob object from the HTML content
      const blob = new Blob([htmlContent], { type: "text/html" });

      // Create a URL for the Blob object
      const baseUrl = URL.createObjectURL(blob);

      // Open the URL in a new tab
      window.open(baseUrl, "_blank");
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="`Pbx Ticket  #${
        this.ticket_form_data && this.ticket_form_data.ticket_number
          ? this.ticket_form_data.ticket_number
          : '...'
      }`"
      :isButton="true"
      :action="goBack"
      text="Go Back"
    />
    <div class="row">
      <div class="col-md-3">
        <div class="card mb-3">
          <div class="p-3 text-capitalize" v-if="isLoading">
            <div class="placeholder-glow" v-for="no in 5" :key="no">
              <p class="placeholder w-25 placeholder-lg"></p>
              <p class="placeholder w-100 placeholder-lg"></p>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="placeholder-glow">
                  <p class="placeholder w-50 placeholder-lg"></p>
                  <p class="placeholder w-100 placeholder-lg"></p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="placeholder-glow">
                  <p class="placeholder w-50 placeholder-lg"></p>
                  <p class="placeholder w-100 placeholder-lg"></p>
                </div>
              </div>
            </div>
            <div class="placeholder-glow">
              <h6
                class="font-weight-semibold placeholder w-100 placeholder-lg"
              ></h6>
              <div
                class="placeholder placeholder-lg w-50 h-160 d-block mx-auto"
              ></div>
            </div>
          </div>
          <div class="position-relative p-3 text-capitalize" v-else>
            <!-- Edit Button -->
            <div v-if="!isEdit" class="req-edit-icon">
              <i
                class="fas fa-pencil-alt text-success fs-5"
                v-b-popover.hover="'Edit request!'"
                @click="handleEdit()"
              ></i>
            </div>
            <!-- TITLE  -->
            <div class="mb-3" v-if="!isEdit">
              <h6 class="font-weight-semibold">title</h6>
              <p>{{ ticket_form_data.ticket_title }}</p>
            </div>
            <div class="mb-3" v-else>
              <h6 class="font-weight-semibold">Title</h6>
              <vue-typeahead-bootstrap
                v-model="ticket_form_data.ticket_title"
                @hit="handleHit"
                :data="titleData"
                trackby="title"
                placeholder="Search title"
                :class="{
                  'is-invalid':
                    submitted && $v.ticket_form_data.ticket_title.$error,
                }"
              />
              <div
                v-if="submitted && $v.ticket_form_data.ticket_title.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.ticket_form_data.ticket_title.required">
                  Select Server is required.
                </span>
              </div>
            </div>
            <!-- PRIORITY -->
            <div class="mb-3">
              <h6 class="font-weight-semibold">Priority</h6>
              <p
                v-if="!isEdit"
                class="badge mb-0 card-badge"
                :class="[
                  ticket_form_data.priority === 'high'
                    ? 'badge-soft-warning'
                    : ticket_form_data.priority === 'urgent'
                    ? 'badge-soft-danger'
                    : ticket_form_data.priority === 'normal'
                    ? 'badge-soft-primary'
                    : 'badge-soft-secondary',
                ]"
              >
                {{ ticket_form_data.priority }}
              </p>
              <b-form-group v-else>
                <b-form-select
                  class="form-select"
                  type="text"
                  v-model="ticket_form_data.priority"
                  :options="priorityOptions"
                  :class="{
                    'is-invalid':
                      submitted && $v.ticket_form_data.priority.$error,
                  }"
                ></b-form-select>
                <div
                  v-if="submitted && $v.ticket_form_data.priority.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.ticket_form_data.priority.required">
                    Select Server is required.
                  </span>
                </div>
              </b-form-group>
            </div>
            <!-- STATUS -->
            <div class="mb-3">
              <h6 class="font-weight-semibold">Status</h6>
              <p
                v-if="!isEdit"
                class="badge mb-0 card-badge"
                :class="[
                  ticket_form_data.status === 'closed'
                    ? 'badge-soft-success'
                    : ticket_form_data.status === 'assigned'
                    ? 'badge-soft-danger'
                    : ticket_form_data.status === 'new'
                    ? 'badge-soft-secondary'
                    : ticket_form_data.status === 'development'
                    ? 'badge-soft-warning'
                    : ticket_form_data.status === 'openL1'
                    ? 'badge-soft-danger'
                    : ticket_form_data.status === 'openL2'
                    ? 'badge-soft-warning'
                    : ticket_form_data.status === 'openL3'
                    ? 'badge-soft-primary'
                    : ticket_form_data.status === 'waiting'
                    ? 'badge-soft-primary'
                    : 'badge-soft-secondary',
                ]"
              >
                {{ ticket_form_data.status }}
              </p>
              <b-form-group v-else>
                <b-form-select
                  class="form-select"
                  type="text"
                  v-model="ticket_form_data.status"
                  :options="statusOptions"
                ></b-form-select>
              </b-form-group>
            </div>
            <!-- ASSIGN TO -->
            <div class="mb-3">
              <h6 class="font-weight-semibold">Assigned To</h6>
              <p
                class="badge mb-0 card-badge badge-soft-success"
                v-if="!isEdit"
              >
                {{
                  ticket_form_data.assign_to_user_name
                    ? ticket_form_data.assign_to_user_name
                    : "-"
                }}
              </p>
              <b-form-group v-else>
                <multiselect
                  v-model="ticket_form_data.assign_to_user_uuid"
                  :options="assignedToOptions"
                  :show-labels="false"
                  track-by="value"
                  label="text"
                  placeholder="Assign to user"
                  :class="{
                    'is-invalid':
                      submitted &&
                      $v.ticket_form_data.assign_to_user_uuid.$error,
                  }"
                ></multiselect>
                <div
                  v-if="
                    submitted && $v.ticket_form_data.assign_to_user_uuid.$error
                  "
                  class="invalid-feedback"
                >
                  <span
                    v-if="!$v.ticket_form_data.assign_to_user_uuid.required"
                  >
                    Select Domain is required.
                  </span>
                </div>
              </b-form-group>
            </div>
            <!-- NAME  -->
            <div class="mb-3" v-if="!isEdit">
              <h6 class="font-weight-semibold">Caller Name</h6>
              <p>{{ ticket_form_data.caller_name }}</p>
            </div>
            <div class="mb-3" v-else>
              <h6 class="font-weight-semibold">Caller Name</h6>
              <b-form-input
                v-model="ticket_form_data.caller_name"
                :class="{
                  'is-invalid':
                    submitted && $v.ticket_form_data.caller_name.$error,
                }"
              />
              <div
                v-if="submitted && $v.ticket_form_data.caller_name.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.ticket_form_data.caller_name.required">
                  Name is required.
                </span>
              </div>
            </div>
            <!-- MOBILE NUMBER  -->
            <div class="mb-3" v-if="!isEdit">
              <h6 class="font-weight-semibold">Caller Number</h6>
              <p>{{ ticket_form_data.caller_number }}</p>
            </div>
            <div class="mb-3" v-else>
              <h6 class="font-weight-semibold">Caller Number</h6>
              <b-form-input
                v-model="ticket_form_data.caller_number"
                :class="{
                  'is-invalid':
                    submitted && $v.ticket_form_data.caller_number.$error,
                }"
              />
              <div
                v-if="submitted && $v.ticket_form_data.caller_number.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.ticket_form_data.caller_number.required">
                  Select Server is required.
                </span>
              </div>
            </div>
            <!-- EMAIL  -->
            <div class="mb-3" v-if="!isEdit">
              <h6 class="font-weight-semibold">Caller Email</h6>
              <p>{{ ticket_form_data.caller_email }}</p>
            </div>
            <div class="mb-3" v-else>
              <h6 class="font-weight-semibold">Caller Email</h6>
              <b-form-input
                v-model="ticket_form_data.caller_email"
                :class="{
                  'is-invalid':
                    submitted && $v.ticket_form_data.caller_email.$error,
                }"
              />
              <div
                v-if="submitted && $v.ticket_form_data.caller_email.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.ticket_form_data.caller_email.required">
                  Select Server is required.
                </span>
              </div>
            </div>
            <!-- CREATED BY -->
            <div>
              <!-- <div class="row mb-2">
                <div class="col-md-6">
                  <h6 class="font-weight-semibold">Caller Name</h6>
                  <p class="mb-0">
                    {{ ticket_form_data.caller_name }}
                  </p>
                </div>
                <div class="col-md-6">
                  <h6 class="font-weight-semibold">Caller Email</h6>
                  <p class="mb-0">
                    {{ ticket_form_data.caller_email }}
                  </p>
                </div>
              </div> -->
              <div class="row">
                <div class="col-md-6">
                  <h6 class="font-weight-semibold">Create By</h6>
                  <p class="mb-0">
                    {{ ticket_form_data.created_by }}
                  </p>
                </div>
                <div class="col-md-6">
                  <h6 class="font-weight-semibold">Created At</h6>
                  <p class="mb-0">
                    {{
                      ticket_form_data.created_at
                        ? convertTime(ticket_form_data.created_at)
                        : "-"
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <!-- <hr /> -->
              <div class="d-flex justify-content-end" v-if="isEdit">
                <button
                  class="btn btn-danger d-block"
                  @click="
                    isEdit = !isEdit;
                    submitted = false;
                  "
                >
                  Cancel
                </button>
                <button
                  class="btn btn-primary d-block ms-2"
                  :disabled="isBtnLoading"
                  @click="updateTicket()"
                >
                  <i
                    v-if="isBtnLoading"
                    class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                  ></i>
                  Save
                </button>
              </div>
            </div>
            <!-- Attachment Image -->
            <!-- <div class="col-md-12">
              <h6 class="font-weight-semibold">Attachment</h6>
              <hr />
              <img
                :src="ticket_form_data.attachment"
                alt=""
                class="d-block mx-auto mw-100 attachment-img"
              />
            </div> -->
          </div>
        </div>
      </div>
      <!-- Add New button -->
      <div class="col-md-9">
        <div class="request-scrollble">
          <div class="mb-3">
            <div class="mb-3" v-if="isLoading">
              <h5 class="placeholder-glow"></h5>
              <p class="placeholder w-100 placeholder-lg"></p>
              <h5 class="placeholder-glow"></h5>
              <p class="placeholder w-100 placeholder-lg"></p>
              <h5 class="placeholder-glow"></h5>
              <p class="placeholder w-100 placeholder-lg"></p>
            </div>
            <div v-else>
              <template
                v-if="
                  ticket_form_data.ticket_activities &&
                  ticket_form_data.ticket_activities.length !== 0
                "
              >
                <div
                  v-for="(data, index) in ticket_form_data.ticket_activities"
                  :key="data.id"
                >
                  <div class="card mb-3">
                    <div
                      class="p-3"
                      :class="data.is_internal ? 'bg-soft bg-warning' : ''"
                    >
                      <div
                        class="d-flex align-items-center justify-content-between"
                      >
                        <h6 class="mb-0">
                          {{ "Log #" }}
                          {{
                            ticket_form_data.ticket_activities.length - index
                          }}
                        </h6>
                        <div v-if="data.created_at" class="">
                          <p class="mb-0 text-end">
                            {{ convertTime(data.created_at) }}
                          </p>
                        </div>
                      </div>
                      <hr class="my-2" />
                      <div class="d-flex">
                        <div class="w-100 me-3">
                          <div>
                            <h6 class="fw-bold">Description</h6>
                            <p>
                              {{ data.description ? data.description : "-" }}
                            </p>
                          </div>
                          <div
                            class="d-flex align-items-center justify-content-between"
                          >
                            <div v-if="data.attachment">
                              <h6 class="fw-bold">View Attachment</h6>

                              <button
                                class="btn btn-primary"
                                @click="viewAttachment(data.attachment)"
                              >
                                View
                              </button>
                            </div>
                            <div class="d-flex align-items-center">
                              <h6 class="fw-bold mb-0">Created By</h6>
                              <span class="mx-1">:</span>
                              <p class="mb-0">{{ data.created_by }}</p>
                            </div>
                          </div>
                        </div>
                        <!-- <div>
                          <div
                            class="log-attachment-img d-flex align-items-center justify-content-center"
                            v-if="
                              data.attachment &&
                              (data.attachment.includes('jpg') ||
                                data.attachment.includes('png') ||
                                data.attachment.includes('jpeg'))
                            "
                          >
                            <img
                              :src="data.attached"
                              alt=""
                              class="log-attachment-img d-block ms-auto rounded"
                            />
                          </div>
                          <div v-else @click="viewAttachment(data.attachment)">
                            <button
                              class="btn btn-primary"
                              @click="viewAttachment(data.attachment)"
                            >
                              View
                            </button>
                          </div>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <h6 class="mb-3">No logs found...</h6>
              </template>
            </div>
          </div>
          <div class="sticky-btn">
            <button
              v-if="!isEdit"
              class="btn btn-primary"
              v-b-modal.add-note-modal
            >
              New Note
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal is used for add new ticket note -->
    <b-modal
      id="add-note-modal"
      title="Add Reply to Ticket"
      hide-footer
      title-class="font-18"
      @hidden="resetModal"
    >
      <div class="row">
        <div
          class="col-md-12"
          :class="!add_note_form.is_internal || 'bg-soft bg-warning'"
        >
          <div class="mb-3">
            <label for="description">
              Description <span class="text-danger">*</span>
            </label>
            <textarea
              class="form-control form-control-sm"
              cols="5"
              rows="6"
              v-model="add_note_form.description"
              :class="{
                'is-invalid': submitted && $v.add_note_form.description.$error,
              }"
            ></textarea>
            <div v-if="submitted" class="invalid-feedback">
              <span v-if="!$v.add_note_form.description.required">
                Description is required.
              </span>
            </div>
            <label class="my-2"
              >Status (
              <p
                v-if="!isEdit"
                class="badge mb-0 card-badge"
                :class="[
                  ticket_form_data.status === 'closed'
                    ? 'badge-soft-success'
                    : ticket_form_data.status === 'assigned'
                    ? 'badge-soft-danger'
                    : ticket_form_data.status === 'new'
                    ? 'badge-soft-secondary'
                    : ticket_form_data.status === 'development'
                    ? 'badge-soft-warning'
                    : ticket_form_data.status === 'openL1'
                    ? 'badge-soft-danger'
                    : ticket_form_data.status === 'openL2'
                    ? 'badge-soft-warning'
                    : ticket_form_data.status === 'openL3'
                    ? 'badge-soft-primary'
                    : ticket_form_data.status === 'waiting'
                    ? 'badge-soft-primary'
                    : 'badge-soft-secondary',
                ]"
              >
                {{ ticket_form_data.status }}
              </p>
              )
            </label>
            <b-form-select
              class="form-select"
              type="text"
              v-model="add_note_form.status"
              :options="statusOptions"
            ></b-form-select>
          </div>
        </div>
        <div class="col-md-12">
          <div class="mb-3">
            <div class="d-flex align-items-center">
              <label for="type_change" class="cursor form-check-label">
                External
              </label>
              <div class="form-check form-switch form-switch-md d-flex ms-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="type_change"
                  v-model="add_note_form.is_internal"
                />
                <label
                  for="type_change"
                  class="form-check-label align-items-center"
                >
                  Internal
                </label>
              </div>
            </div>
          </div>
        </div>
        <p class="text-danger ms-2" v-show="!add_note_form.is_internal">
          Note : Email notification send.
        </p>

        <div class="col-md-12">
          <div class="mb-3">
            <label for="attachment" class="d-block">Attachment</label>
            <input
              class="form-control"
              @change="uploadFile($event)"
              type="file"
            />
          </div>
        </div>

        <div class="col-md-12">
          <hr />
          <b-button
            class="float-end ms-2"
            variant="outline-primary"
            type="reset"
            @click="resetModal"
          >
            Cancel
          </b-button>
          <b-button
            variant="outline-primary"
            class="float-end"
            type="submit"
            @click="addNewNote()"
            ><i
              v-if="isBtnLoading"
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
            ></i>
            Save
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<style scoped>
.request-scrollble {
  max-height: calc(100vh - 130px);
  overflow-y: scroll;
  overflow-x: hidden;
}

.req-edit-icon {
  position: absolute;
  top: 16px;
  right: 16px;
}

.attachment-img {
  object-fit: cover;
  max-height: 160px;
}

.h-160 {
  height: 160px;
}

.log-attachment-img {
  width: 100px;
  height: 100px;
  object-fit: cover;
}

.sticky-btn {
  position: sticky;
  bottom: 0;
}
</style>
